import DeepLinkStartProgramView from 'components/views/DeepLinkStartProgramView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { actionCreators as eventsAC } from 'store/events';
import { actionCreators as loginAC, getHasAuthenticationLoaded, getIsAuthenticated } from 'store/login';
import { getIsAnamnesisDone, getIsProfileLoaded } from 'store/profile';
import { actionCreators as programPreviewAC } from 'store/programPreview';
import { WithRouterType } from 'types/withRouter';

export const mapStateToProps = (state, ownProps: Object & WithRouterType) => ({
	id: ownProps.match.params.id,
	isAuthenticated: getIsAuthenticated(state),
	isAnamnesisDone: getIsAnamnesisDone(state),
	hasAuthenticationLoaded: getHasAuthenticationLoaded(state),
	isProfileLoaded: getIsProfileLoaded(state),
});

export const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({ ...eventsAC, ...programPreviewAC, ...loginAC }, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeepLinkStartProgramView) as any);
